import React from "react";

function Spacer ({ value }) {
  return <span style={{ paddingTop: value }}></span>;
}

export default Spacer;
